import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
import { Box, xcss } from '@atlaskit/primitives';
import Icon from '@atlaskit/icon';

const t25IconContainerStyles = {
	small: xcss({
		width: '16px',
		height: '16px',
	}),
	medium: xcss({
		width: '24px',
		height: '24px',
	}),
	large: xcss({
		width: '32px',
		height: '32px',
	}),
	//t25 tile icons do not get bumped up to 40/48px to avoid additional padding
	xlarge: xcss({
		width: '32x',
		height: '32px',
	}),
} as const;

export interface SVGIconProps {
	glyph: () => JSX.Element;
	label?: string;
	size: Size;
}

const iconStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

export function getLogoVersion(t25LogoComponent: any, LogoComponent: any) {
	return t25LogoComponent;
}

export function get3PLogo(iconGlyph: () => JSX.Element, iconLabel: string): RovoLogo {
	return fg('rovo_search_custom_icon_component')
		? RovoLogoFromSVG(iconGlyph, iconLabel)
		: RovoLogoFromGlyph(iconGlyph, iconLabel);
}

export type RovoLogoGlyphWrapper = (
	glyph: () => JSX.Element,
	defaultLabel?: string,
	defaultSize?: Size,
) => RovoLogo;

export type RovoLogoProps = {
	size?: Size;
	label?: string;
	testId?: string;
};

export type RovoLogo = (props: RovoLogoProps) => JSX.Element;

export const SVGIcon = ({ glyph: SVG, label, size }: SVGIconProps) => {
	return (
		<Box xcss={[t25IconContainerStyles[size], iconStyles]} aria-label={label}>
			<SVG />
		</Box>
	);
};

type Size = 'small' | 'medium' | 'xlarge';

export type RovoLogoLogoWrapper = (LogoComponent: any, defaultLabel?: string) => RovoLogo;

export const RovoLogoFromLogo: RovoLogoLogoWrapper = (LogoComponent, defaultLabel = '') => {
	return ({ label, testId }) => {
		return (
			<LogoComponent
				label={label || defaultLabel}
				testId={testId}
				size="small"
				appearance="brand"
			/>
		);
	};
};

export const RovoLogoFromSVG: RovoLogoGlyphWrapper = (glyph, defaultLabel = '') => {
	return ({ label = defaultLabel }) => <SVGIcon label={label} glyph={glyph} size="medium" />;
};

export const RovoLogoFromGlyph: RovoLogoGlyphWrapper = (glyph, defaultLabel = '') => {
	return ({ label = defaultLabel, testId }) => {
		return <Icon label={label} testId={testId} glyph={glyph} size="medium" />;
	};
};
